
import React from 'react';
import CategoryTabs from './CategoryTabs';
import SearchBar from './SearchBar';
import ProviderControls from './ProviderControls';

interface MedicationsNavbarProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  isAuthenticated: boolean;
  isProviderView: boolean;
  toggleProviderView: () => void;
  logout: () => void;
  scrollToCategory: (categoryId: string) => void;
  categoryCounts: Record<string, number>;
}

const MedicationsNavbar: React.FC<MedicationsNavbarProps> = ({
  searchTerm,
  setSearchTerm,
  isAuthenticated,
  isProviderView,
  toggleProviderView,
  logout,
  scrollToCategory,
  categoryCounts,
}) => {
  return (
    <div className="sticky top-16 z-40 w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b">
      <div className="container py-2">
        <div className="flex justify-between items-center">
          <CategoryTabs 
            scrollToCategory={scrollToCategory} 
            categoryCounts={categoryCounts}
            searchTerm={searchTerm}
          />
          
          <div className="flex items-center gap-3 ml-2">
            <SearchBar 
              searchTerm={searchTerm} 
              setSearchTerm={setSearchTerm} 
            />
            
            <ProviderControls 
              isAuthenticated={isAuthenticated}
              isProviderView={isProviderView}
              toggleProviderView={toggleProviderView}
              logout={logout}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicationsNavbar;
